import { render, staticRenderFns } from "./HasBloodTransfusion.vue?vue&type=template&id=e4fa32d0&"
import script from "./HasBloodTransfusion.vue?vue&type=script&lang=js&"
export * from "./HasBloodTransfusion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports